export default __webpack_public_path__ + "static/media/break.1f05981c.svg";